import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { Variaveis } from './Variaveis';
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

class ApiService {
  private axiosInstance: AxiosInstance;

  constructor() {
    const token = localStorage.getItem("token")
    this.axiosInstance = axios.create({
      baseURL: Variaveis.urlServer,
      headers: {
        'Authorization': 'Bearer ' + token,
        'Accept': '*/*',
        'Content-Type': 'application/json'
      }
    });

    this.axiosInstance.interceptors.response.use(
      this.handleSuccess,
      this.handleError
    );
  }

  private handleSuccess(response: AxiosResponse): AxiosResponse {
    return response;
  }

  private handleError(error: any): Promise<never> {
    if (error.response) {
      const { status, data } = error.response;
      console.error(`Erro HTTP ${status}: ${data.message || 'Erro desconhecido'}`);
      if(status == 403) history.push('/');
    } else if (error.request) {
      console.error('Nenhuma resposta recebida do servidor.');
    } else {
      console.error('Erro na configuração da requisição:', error.message);
    }
    return Promise.reject(error);
  }

  public get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.axiosInstance.get<T>(url, config).then((response) => response.data);
  }

  public post<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return this.axiosInstance.post<T>(url, data, config).then((response) => response.data);
  }

  public put<T>(url: string, data: any, config?: AxiosRequestConfig): Promise<T> {
    return this.axiosInstance.put<T>(url, data, config).then((response) => response.data);
  }

  public delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.axiosInstance.delete<T>(url, config).then((response) => response.data);
  }
}

export default ApiService;
